<script>
    import {Link} from 'svelte-routing';
    
    export let title = '';
</script>

<!-- App Bottom Menu -->
<div class="appBottomMenu">
    <Link to="/dashboard" class="item">
        <div class="col">
            <ion-icon name="file-tray-full-outline" role="img" class="md hydrated" aria-label="file tray full outline"></ion-icon>
            <strong>Задачи</strong>
        </div>
    </Link>
    <Link to="/create" class="item">
        <div class="col">
            <div class="action-button large">
                <ion-icon name="add-outline" role="img" class="md hydrated" aria-label="add outline"></ion-icon>
            </div>
        </div>
    </Link>
    <Link to="/profile" class="item">
        <div class="col">
            <ion-icon name="people-outline" role="img" class="md hydrated" aria-label="people outline"></ion-icon>
            <strong>Профиль</strong>
        </div>
    </Link>
</div>
<!-- * App Bottom Menu -->
